import AjaxBase from '../../../lib/AjaxBase';

export default class DataService extends AjaxBase {
  /* ----------
  How to call api & handle response:

  TeacherDataService.login({key1: data1, key2: data2}).then((response) => {
    // correct response is JSON format
    // to do something
  }, (response) => {
    // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
  }).catch((error) => {
    // catch any error above block ('then' block)
    // to do something
  });
  ----------- */
  static userLogout() {
    return super.put(super.URL_PREFIX + `users/logout`);
  }

  /* ============================ teacehr & student ============================ */
  static getUserInfo() {
    return super.get(super.URL_PREFIX + "users/self", {});
  }

  static searchTeacher(name, school_id) {
    return super.get(super.URL_PREFIX + "teachers/search", {name: name, school_id: school_id});
  }

  static searchSchool(data) {
    return super.get(super.URL_PREFIX + "schools", data);
  }

  static searchUser(data) {
    return super.get(super.URL_PREFIX + "admin/users/search", data);
  }

  static unbindUserWxAccount(id){
    return super.post(super.URL_PREFIX + "users/unbind",{id:id});
  }

  static searchStudent(data) {
    return super.get(super.URL_PREFIX + "students/search", data);
  }

  static updateUserMobile(data) {
    return super.put(super.URL_PREFIX + `admin/users/${data.id}`, data);
  }

  static getAllTeachers(data) {
    return super.get(super.URL_PREFIX + `teachers/index`, data)
  }

  static getOneTeacherInfo(id) {
    return super.get(super.URL_PREFIX + `teachers/${id}`, {})
  }

  static getAllClassRecord(school_id) {
    return super.get(super.URL_PREFIX + `classes`, { school_id: school_id })
  }

  static getAllClassGrade(school_id) {
    return super.get(super.URL_PREFIX + `schools/${school_id}/class_grades`, {})
  }

  static getAllSchools(type){
    return super.get(super.URL_PREFIX + `admin/schools/school_lists`,{type:type})
  }
  static postTeacher(teacher) {
    if (teacher.id) {
      return super.put(super.URL_PREFIX + `teachers/${teacher.id}`, teacher);
    } else {
      return super.post(super.URL_PREFIX + `teachers`, teacher);
    }
  }

  static deleteTeacher(data) {
    return super.put(super.URL_PREFIX + `teachers/remove_from_school`, data)
  }

  static setAdmin(data) {
    return super.put(super.URL_PREFIX + `teachers/${data.teacher_id}/add_role`, data)
  }

  static deleteAdmin(data) {
    return super.delete(super.URL_PREFIX + `teachers/${data.teacher_id}/remove_role`, data)
  }

  static getStudents(classId) {
    return super.get(super.URL_PREFIX + `students`, {class_id: classId});
  }

  static getOneStudentInfo(studentId) {
    return super.get(super.URL_PREFIX + `students/${studentId}`, {});
  }

  /* ============================ classinfo ============================= */
  static getStudentsOfClass(classId) {
    return super.get(super.URL_PREFIX + `students`, {class_id: classId})
  }

  static getStudentsStatistics(classId) {
    return super.get(super.URL_PREFIX + `student_statistics`, {class_record_id: classId})
  }

  static getClassList(data) {
    return super.get(super.URL_PREFIX + `classes`, data)
  }

  static getClassById(classId) {
    return super.get(super.URL_PREFIX + `classes/${classId}`, {})
  }

  /* ============================ post ============================ */
  static getAlbumPosts(albumId, data) {
    return super.get(super.URL_PREFIX + `albums/${albumId}/posts`, data);
  }

  static getStudentPosts(studentId, data) {
    return super.get(super.URL_PREFIX + `students/${studentId}/profile`, data);
  }

  static createPost(albumId, data) {
    return super.post(super.URL_PREFIX + `albums/${albumId}/posts`, data);
  }

  static destroyPost(postId) {
    return super.delete(super.URL_PREFIX + `posts/${postId}`, {});
  }

  static createTag(data) {
    return super.post(super.URL_PREFIX + `student_tags`, data);
  }

  static deleteTag(tagId) {
    return super.delete(super.URL_PREFIX + `student_tags/${tagId}`);
  }
  static addPostLikes(data) {
    return super.post(super.URL_PREFIX + `likes`, data);
  }

  static deletePostLikes(postId) {
    return super.delete(super.URL_PREFIX + `likes/${postId}`);
  }

  static addPostComment(data) {
    return super.post(super.URL_PREFIX + `comments`, data);
  }

  static deletePostComment(id) {
    return super.delete(super.URL_PREFIX + `comments/${id}`);
  }

  static updatePost(postId, data) {
    return super.put(super.URL_PREFIX + `posts/${postId}`, data);
  }

  static showOnePost(postId) {
    return super.get(super.URL_PREFIX + `posts/${postId}`);
  }

  /* ============================ album ============================ */
  static getAlbumList(classId) {
    return super.get(super.URL_PREFIX + `albums`, {class_record_id: classId})
  }

  static getAlbum(albumId) {
    return super.get(super.URL_PREFIX + `albums/${albumId}`)
  }

  static createAlbum(data) {
    return super.post(super.URL_PREFIX + `albums`, data)
  }

  static updateAlbum(albumId, data) {
    return super.put(super.URL_PREFIX + `albums/${albumId}`, data)
  }

  static deleteAlbum(albumId) {
    return super.delete(super.URL_PREFIX + `albums/${albumId}`)
  }

  /* ============================ school admin ============================ */
  static getAllStudents(classId) {
    return super.get(super.URL_PREFIX + "students", {class_id: classId});
  }

  static getAllTeachers(data) {
    return super.get(super.URL_PREFIX + "teachers/index", data);
  }

  static removeStudent(stuId) {
    return super.delete(super.URL_PREFIX + "students/" + stuId);
  }

  static updateStudent(stuId, avatar, name, inner_code) {
    let data = {
      avatar_url: avatar,
      full_name: name
    }
    if (inner_code) {
      data.inner_code = inner_code
    }
    return super.put(super.URL_PREFIX + `students/${stuId}`, data);
  }

  static changeStudentClass(studentId, classId) {
    return super.put(super.URL_PREFIX + `students/${studentId}/change_student_class`, {class_id: classId});
  }

  static createStudent(studentInfo) {
    return super.post(super.URL_PREFIX + "students", studentInfo);
  }

  static setClassAdmin(classId, teacherId) {
    return super.put(super.URL_PREFIX + `classes/${classId}/set_admin`, {teacher_id: teacherId});
  }

  static removeTeacher(teacherId, classId) {
    return super.put(super.URL_PREFIX + `teachers/${teacherId}/quit_class`, {class_id: classId});
  }

  static addTeacher(teacherId, classId) {
    return super.put(super.URL_PREFIX + `teachers/${teacherId}/join_class`, {class_id: classId});
  }

  // 添加老师前按手机号预检: not_found / in_class / in_school / other_school，同时核对填写的姓名(name_matched)
  static lookupClassTeacher(classId, mobilePhone, fullName) {
    return super.post(super.URL_PREFIX + `classes/${classId}/teachers/lookup`, {mobile_phone: mobilePhone, full_name: fullName});
  }

  // 按手机号把老师加入班级: 老师不存在则创建, 不在本校则先加入本校
  static addTeacherToClass(classId, mobilePhone, fullName) {
    return super.post(super.URL_PREFIX + `classes/${classId}/teachers`, {mobile_phone: mobilePhone, full_name: fullName});
  }

  static getAllClassesMember(schoolId) {
    return super.get(super.URL_PREFIX + "classes", {school_id: schoolId, info: 'member'});
  }

  static createClass(newClass) {
    return super.post(super.URL_PREFIX + "classes", newClass);
  }

  static updateClass(id, name) {
    return super.put(super.URL_PREFIX + `classes/${id}`, {name: name});
  }

  static deleteClass(classId) {
    return super.delete(super.URL_PREFIX + `classes/${classId}`);
  }

  static createClassGrade(schoolId, data) {
    return super.post(super.URL_PREFIX + `schools/${schoolId}/class_grades`, data);
  }

  static getUsageData(data) {
    return super.get(super.URL_PREFIX + `reports/usage_data`,data)
  }

  static getClassUsageData(data) {
    return super.get(super.URL_PREFIX + `reports/class_usage_data`, data)
  }

  static getRegisterationData(data) {
    return super.get(super.URL_PREFIX + `reports/school_registeration`,data)
  }

  /* ============================ notification ============================ */
  static createNotification(title, content, photos, visibilityClassIds) {
    return super.post(super.URL_PREFIX + `notifications`, {title: title, content: content, photos: photos, visibility_class_ids: visibilityClassIds});
  }

  static getNotifications(classId, includeVisibility = false) {
    return super.get(super.URL_PREFIX + `notifications`, {class_id: classId, include_visibility: includeVisibility});
  }

  static readNotifications(notificationIds, studentId) {
    return super.put(super.URL_PREFIX + `notifications/read`, {notification_ids: notificationIds, student_id: studentId})
  }

  /* ============================ archive ============================ */
  static getTemplateById(templateId) {
    return super.get(super.URL_PREFIX + `templates/${templateId}`);
  }

  static getUnreadNotificationsCount(classId, studentId) {
    return super.get(super.URL_PREFIX + `notifications/unread_count`, {class_id: classId, student_id: studentId});
  }

  static revokeNotification(notificationId, classId) {
    return super.delete(super.URL_PREFIX + `notifications/${notificationId}`, {class_id: classId});
  }

  static readNotifications(notificationIds, studentId) {
    return super.put(super.URL_PREFIX + `notifications/read`, {notification_ids: notificationIds, student_id: studentId})
  }

  /* ============================ archive ============================ */
  static getTemplatesInfo(templateId) {
    return super.get(super.URL_PREFIX + `templates/${templateId}`)
  }

  static hideTemplate(templateId){
    return super.put(super.URL_PREFIX + `templates/hide`,{id:templateId})
  }

  static getPageContents(page_id, student_id) {
    return super.get(super.URL_PREFIX + `pages/${page_id}/students/${student_id}/page_contents/show`)
  }

  static getArchives(classId, semester) {
    return super.get(super.URL_PREFIX + `classes/${classId}/semester/${semester}/archives`)
  }

  static getStudentArchivesContent(studentId, semester) {
    return super.get(super.URL_PREFIX + `student_archives`, {student_id: studentId, semester: semester })
  }

  static reviewPageContent(pageContentId) {
    return super.put(super.URL_PREFIX + `page_contents/${pageContentId}/review`, {})
  }

  static getClassProgress(archiveId) {
    return super.get(super.URL_PREFIX + `archives/${archiveId}/class_progress`, {})
  }

  static getArchivesSemesters(classId) {
    return super.get(super.URL_PREFIX + `classes/${classId}/semesters`, {})
  }

  static getArchiveStatusForSchool(schoolId) {
    return super.get(super.URL_PREFIX + `classes`, {school_id: schoolId, info: "review"});
  }

  static getArchiveStatusForClass(classId, semester, isForReview) {
    let data = isForReview ? {for_review: true} : {};
    return super.get(super.URL_PREFIX + `classes/${classId}/semester/${semester}/archives`, data);
  }

  static getAllThemes(archiveId) {
    return super.get(super.URL_PREFIX + `themes`, {archive_id: archiveId, with_templates: true});
  }

  static createNewPage(archiveId, pageNumber, author, templateId) {
    return super.post(super.URL_PREFIX + `archives/${archiveId}/pages`, {page_number: pageNumber, page_type: 'inside', author_type: author, template_id: templateId});
  }

  static getAllClasses(schoolId, info) {
    return super.get(super.URL_PREFIX + "classes", {school_id: schoolId, info: info});
  }

  static reorderPages(archiveId, pagesOrder) {
    return super.post(super.URL_PREFIX + `archives/${archiveId}/pages/reorder`, {pages_order: pagesOrder} )
  }

  static removeTheme(pageId) {
    return super.put(super.URL_PREFIX + `pages/${pageId}/remove_theme`)
  }

  static getStudentArchive(stuId, semester) {
    return super.get(super.URL_PREFIX + `students/${stuId}/semester/${semester}/archives`);
  }

  static destroyPageContents(data) {
    return super.delete(super.URL_PREFIX + `page_contents/patch_destroy`, data)
  }

  static getStudentArchiveStatus(archive_id, student_id) {
    return super.get(super.URL_PREFIX + `archives/${archive_id}/student/${student_id}/progress`)
  }

  static batchPublishPageContents(student_ids, page_id, album_id = undefined) {
    return super.put(super.URL_PREFIX + `page_contents/batch_update`, { student_ids: student_ids, page_id: page_id, album_id: album_id})
  }

  static batchClassPageContents(class_id, page_id, album_id = undefined) {
    return super.put(super.URL_PREFIX + `page_contents/batch_update`, { class_id: class_id, page_id: page_id, album_id: album_id})
  }

  static batchChangeClassPageContentAlbumTitle(class_id, page_id, album_title) {
    return super.put(super.URL_PREFIX + `page_contents/batch_update`, { class_id: class_id, page_id: page_id, album_title: album_title })
  }

  static createPageContents(data) {
    return super.post(super.URL_PREFIX + `page_contents`, data);
  }

  static getPageContents(pageId, studentId) {
    return super.get(super.URL_PREFIX + `pages/${pageId}/students/${studentId}/page_contents/show`);
  }

  static toolAnswers(has_answer, question_area_id, data) {
    if (has_answer)
      return super.post(super.URL_PREFIX + `question_area/${question_area_id}/question_answers/update`, data)
    else
      return super.post(super.URL_PREFIX + `question_area/${question_area_id}/question_answers`, data)
  }

  static getClassStatus(classId, pageId) {
    return super.get(super.URL_PREFIX + 'pages/class_status', {class_record_id: classId, page_id: pageId});
  }

  static getArchiveStudentList(archiveId) {
    return super.get(super.URL_PREFIX + `archives/${archiveId}/class_progress`)
  }

  static createBookOrders(data) {
    return super.post(super.URL_PREFIX + `book_orders/create`, data)
  }

  static updateBookOrders(data){
    return super.put(super.URL_PREFIX + `book_orders/force_update_pdf`, data)
  }

  static sendBookToArchiveMail(data) {
    return super.get(super.URL_PREFIX + `book_orders/send_archive_mail`, data)
  }

  /* ============================ set official account  ============================ */

  static getAutoRepliesList() {
    return super.get(super.URL_PREFIX + `admin/auto_replies`, {})
  }

  static getAutoRepliesMedias(data) {
    return super.get(super.URL_PREFIX + `admin/auto_replies/medias`, data)
  }

  static deleteAutoRepliesMedias(id) {
    return super.delete(super.URL_PREFIX + `admin/auto_replies/${id}`, {})
  }

  static createAutoReplies(data) {
    return super.post(super.URL_PREFIX + `admin/auto_replies`, data)
  }

  /* ============================ set official account  ============================ */
  static getTaskList() {
    return super.get(super.URL_PREFIX + `admin/pdf_tasks`)
  }

  static createTask(data) {
    return super.post(super.URL_PREFIX + `admin/pdf_tasks`, data)
  }

  static taskRenderPdf(id) {
    return super.put(super.URL_PREFIX + `admin/pdf_tasks/render_pdf`, {id})
  }
  static taskTryErrorPdf(id) {
    return super.put(super.URL_PREFIX + `admin/pdf_tasks/try_error_pdf`, { id })
  }

  static taskPushParent(id) {
    return super.put(super.URL_PREFIX + `admin/pdf_tasks/push_parent`, { id })
  }

  static taskPushTeacher(id) {
    return super.put(super.URL_PREFIX + `admin/pdf_tasks/push_teacher`, { id })
  }

  /* ============================ change theme title  ============================ */
  static createComment(id, comment) {
    return super.put(super.URL_PREFIX + `/pages/create_comment/${id}`, { comment })
  }

  /* ============================ attendance  ============================ */
  static getSchoolInfo(id) {
    return super.get(super.URL_PREFIX + `schools/${id}`, {})
  }

  static getCalendars(data) {
    return super.get(super.URL_PREFIX + `calendars`, data)
  }

  static createCalendarDate(data) {
    return super.put(super.URL_PREFIX + `schools/set_semester`, data)
  }

  static createCalendars(data) {
    return super.post(super.URL_PREFIX + `calendars/batch_create`, data)
  }

  static getClockOnRecords(data) {
    return super.get(super.URL_PREFIX + `clock_on_records`, data)
  }

  static getClassesAttendance(data) {
    return super.get(super.URL_PREFIX + `clock_on_records/school_student_absence`, data)
  }

  static getClassDetailAttendance(data) {
    return super.get(super.URL_PREFIX + `clock_on_records/class_absence`, data)
  }

  static getSemesterRecord(data) {
    return super.get(super.URL_PREFIX + `clock_on_records/semester_record`, data)
  }

  static batchUpdateAttendance(data) {
    return super.post(super.URL_PREFIX + `clock_on_records/batch_update`, data)
  }

  static getSumSetGrades(data) {
    return super.get(super.URL_PREFIX + `calendars/sum_set`, data)
  }

  static getStudentStatistic(data) {
    return super.get(super.URL_PREFIX + `clock_on_records/student_statistic`, data)
  }

  static getClassStatistic(data) {
    return super.get(super.URL_PREFIX + `clock_on_records/class_statistic`, data)
  }

  static getSchoolMenu(id) {
    return super.get(super.URL_PREFIX + `schools/${id}/album_menu`, {})
  }

  static getSchoolSetting(id) {
    return super.get(super.URL_PREFIX + `schools/${id}/school_setting`, {})
  }

  static getStudentClockOnReport(data) {
    return super.get(super.URL_PREFIX + `schools/student_clock_on_report`, data)
  }

  static getSchoolAbsenceReasons(school_id) {
    return super.get(super.URL_PREFIX + `absence_reasons`, { school_id })
  }

  // 打卡
  static getDailyAttendanceTasks(data) {
    return super.get(super.URL_PREFIX + `daily_attendance_tasks`, data)
  }

  static completeTask(id) {
    return super.put(super.URL_PREFIX + `daily_attendance_tasks/complete_task`, { id })
  }

  static destroyTask(id) {
    return super.delete(super.URL_PREFIX + `daily_attendance_tasks/${id}`, {})
  }

  static getOneTaskDetail(id) {
    return super.get(super.URL_PREFIX + `daily_attendance_tasks/${id}`, {})
  }

  static getRankInfo(id) {
    return super.get(super.URL_PREFIX + `daily_attendance_tasks/rank_info`, {id})
  }

  static getDailyAttendances(data) {
    return super.get(super.URL_PREFIX + `daily_attendances`, data)
  }

  static getAttendanceInfo(data) {
    return super.get(super.URL_PREFIX + `daily_attendance_tasks/attendance_info`, data)
  }

  static createDailyAttendanceTasks(data) {
    return super.post(super.URL_PREFIX + `daily_attendance_tasks`, data)
  }

  static attendanceRemind(data) {
    return super.put(super.URL_PREFIX + `daily_attendance_tasks/remind`, data)
  }

  // 成长档案配置故事模板
  static searchStory(data) {
    return super.get(super.URL_PREFIX + `stories/search`, data)
  }

  static getPageContentStories(data) {
    return super.get(super.URL_PREFIX + `stories/page_content_stories`, data)
  }

  static batchChangePageContentStory(data) {
    return super.put(super.URL_PREFIX + `page_contents/batch_update`, data)
  }

  // 发展评价
  static getEvaluationCategories(data) {
    return super.get(super.URL_PREFIX + `evaluation_categories`, data)
  }

  static getEvaluationInfo(data) {
    return super.get(super.URL_PREFIX + `evaluations/get_evaluation_info`, data)
  }

  static getEvaluationLevel(data) {
    return super.get(super.URL_PREFIX + `evaluation_levels`, data)
  }

  static getCase(data) {
    return super.get(super.URL_PREFIX + `evaluation_levels/get_case`, data)
  }

  static updateEvaluate(data) {
    return super.put(super.URL_PREFIX + `evaluations/${data.id}`, data)
  }

  static createEvaluate(data) {
    return super.post(super.URL_PREFIX + `evaluations`, data)
  }

  static createAndUpdateEvaluate(data) {
    return super.post(super.URL_PREFIX + `evaluations/create_and_update`, data)
  }

  static getDevelopmentRecords(data) {
    return super.get(super.URL_PREFIX + `observations`, data)
  }

  static getObservationDetail(id) {
    return super.get(super.URL_PREFIX + `observations/${id}`, {})
  }

  static destroyObservationRecord(record_id){
    return super.delete(super.URL_PREFIX + `observations/${record_id}`,{})
  }

  static updateObservationRecord(data){
    return super.put(super.URL_PREFIX + `observations/${data.id}`, data)
  }

  static createObservationRecord(data){
    return super.post(super.URL_PREFIX + `observations`, data)
  }

  static getStudentsList(data) {
    return super.get(super.URL_PREFIX + `students`, data)
  }

  static getEvaluationInstances(data) {
    return super.get(super.URL_PREFIX + `evaluation_instances`, data)
  }

  static getDevelopmentReport(data) {
    return super.get(super.URL_PREFIX + `evaluations/get_report`, data)
  }

  static getClassReportPdf(data){
    return super.get(super.URL_PREFIX + `evaluations/get_class_pdf`, data)
  }

  static getClassReport(data){
    return super.get(super.URL_PREFIX + `evaluations/get_class_report`, data)
  }

  static sendDevelopmentReportToArchiveMail(data){
    return super.post(super.URL_PREFIX + `evaluations/generate_development_report`, data)
  }
  // 上传主题评价
  static createByExcel(data) {
    return super.uploadFile(super.URL_PREFIX + "templates/create_by_excel", { file_name: data.file_name, type: data.type, theme_type: data.theme_type }, undefined, undefined, undefined, data.file, "file")
  }

  // 添加档案页数
  static addPageCount(data) {
    return super.put(super.URL_PREFIX + `archives/add_page_count`, data)
  }

  static removeEmptyPage(archiveId) {
    return super.put(super.URL_PREFIX + `archives/${archiveId}/remove_last_empty_page`, {})
  }

  // 档案进度
  static getClassArchiveStatistics(data) {
    return super.get(super.URL_PREFIX + `statistic_templates/class_archive_statistics`, data)
  }

  static getStatisticTemplateClassStatus(data) {
    return super.get(super.URL_PREFIX + `pages/statistic_template_class_status`, data)
  }

  static getStatisticTemplatesIndex(data) {
    return super.get(super.URL_PREFIX + `statistic_templates`, data)
  }

  static updateStatisticTemplates(data) {
    return super.put(super.URL_PREFIX + `statistic_templates/batch_update`, data)
  }

  // 上传学生名单
  static importStudents(classId, file) {
    return super.uploadFile(super.URL_PREFIX + "classes/import_students", { class_id: classId }, undefined, undefined, undefined, file, "file")
  }

  // 上传全部学生名单
  static importAllStudents(schoolId, file) {
    return super.uploadFile(super.URL_PREFIX + "schools/import_students", { school_id: schoolId }, undefined, undefined, undefined, file, "file")
  }

  // 上传全部老师名单
  static importAllTeachers(schoolId, file) {
    return super.uploadFile(super.URL_PREFIX + "schools/import_teachers", { school_id: schoolId }, undefined, undefined, undefined, file, "file")
  }

}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/lib/DataService.js